var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EF7016"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.125C12.825 33.125 6.875 27.175 6.875 20C6.875 12.825 12.825 6.875 20 6.875C27.175 6.875 33.125 12.125 33.125 18.6C33.125 22.8 29.625 26.3 25.425 26.3H22.975C22.45 26.3 21.925 26.825 21.925 27.35C21.925 27.7 22.1 27.875 22.275 28.05C22.8 28.575 22.975 29.275 22.975 29.975C22.975 31.725 21.575 33.125 20 33.125ZM20 8.8C13.875 8.8 8.8 13.875 8.8 20C8.8 26.125 13.875 31.2 20 31.2C20.525 31.2 21.05 30.675 21.05 30.15C21.05 29.8 20.875 29.625 20.7 29.45C20.175 28.925 20 28.225 20 27.525C20 25.95 21.4 24.55 22.975 24.55H25.425C28.575 24.55 31.2 21.925 31.2 18.775C31.2 13.175 26.125 8.8 20 8.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8251 20.8246C13.8883 20.8246 14.7501 19.9628 14.7501 18.8996C14.7501 17.8365 13.8883 16.9746 12.8251 16.9746C11.762 16.9746 10.9001 17.8365 10.9001 18.8996C10.9001 19.9628 11.762 20.8246 12.8251 20.8246Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.675 15.5746C17.7381 15.5746 18.6 14.7128 18.6 13.6496C18.6 12.5865 17.7381 11.7246 16.675 11.7246C15.6119 11.7246 14.75 12.5865 14.75 13.6496C14.75 14.7128 15.6119 15.5746 16.675 15.5746Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3251 15.5746C24.3883 15.5746 25.2501 14.7128 25.2501 13.6496C25.2501 12.5865 24.3883 11.7246 23.3251 11.7246C22.262 11.7246 21.4001 12.5865 21.4001 13.6496C21.4001 14.7128 22.262 15.5746 23.3251 15.5746Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.175 20.8246C28.2381 20.8246 29.1 19.9628 29.1 18.8996C29.1 17.8365 28.2381 16.9746 27.175 16.9746C26.1119 16.9746 25.25 17.8365 25.25 18.8996C25.25 19.9628 26.1119 20.8246 27.175 20.8246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.445edefa7a4251e339f0efacb6fc53a9.svg";
export { ForwardRef as ReactComponent };